import axios from 'axios';
import vm from '@/main';
import {clearLoginInfo} from "@/utils/index";

const service = axios.create({
  baseURL: process.env.VUE_APP_API || location.origin, // api 的 base_url
  withCredentials: true,
  timeout: 30000 // request timeout
});
let showNoToken = true;
function clearAndJumpLogin(){
  window.localStorage.clear();
  let selfQuery = {
    ...vm.$route.query,
  }
  if(vm.$route.name !== 'login'){
    selfQuery.redirectRouterName = vm.$route.name;
  }
  //为了修复  修改密码弹框跳转到登录页无法自动关闭的问题
  // 获取所有具有指定类名的元素
  var elements = document.querySelectorAll('.active-prompt');

  // 遍历这些元素并移除它们
  elements.forEach(function(element) {
      element.parentNode.removeChild(element);
  });

  // todo redirectRouterName有时 后面没东西
  vm.$router.push({
    name: 'login',
    /*query: selfQuery,
    params: vm.$route.params,*/
  });
}

// request interceptor
service.interceptors.request.use(
  config => {
    config.data = JSON.stringify(config.data);

    config.headers = {
      "Content-Type": 'application/json;charset=UTF-8',
    };
    if(config.url.indexOf('oss/upload') !== -1){
      config.data = config.data;
      config.headers["Content-Type"] = 'multipart/form-data';
    }
    let tokenX = localStorage.getItem('token');
    if(tokenX){
      config.headers['token'] = tokenX;
    }

    if(window.location.origin.indexOf('https') > -1 && config.baseURL.indexOf('https') == -1){
      config.baseURL = config.baseURL.replace('http','https');
    }
    return config;
  },
  error => {
    console.log('requestErr' + error); // for debug
    Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    // 上传图片500的时候没有弹出对应的消息 todo
    if (response.data && response.data.code === 401) { // 401, token失效
      clearLoginInfo(vm.$router);
      clearAndJumpLogin();
    }
    console.log(response);
    // 400报错时,不弹框
    let noCodeUrl = ['/wx/sys/menu/list','/wx/manage/wxAccount/list'];
    console.log(!noCodeUrl.includes(response.config.url));
    if(response.data.code !== 400 && !noCodeUrl.includes(response.config.url) && response.data && response.data.code !== 200 && response.data.code !== 401){
    //暂接口没有统一的返回
      vm.$vs.notify({
        title: '注意',
        text: response.data.msg,
        position: 'top-center',
        color: 'danger',
      });
      return Promise.reject(response.data);
    }
    return response.data;
  },
  error => {

//区分没有登录和登录过token失效 这部分测试 todo
    if(!localStorage.getItem('token') && vm.$route.name != 'login' && showNoToken){
      showNoToken = false;
      vm.$router.push({name: 'login'});
    }else {
      //  登录异常
      if(showNoToken){
        showNoToken = false;
        setTimeout(() => {
          clearAndJumpLogin();
        }, 3000);

        // 需要不用title的dialog todo
        vm.$vs.dialog({
          color: 'danger',
          title: '注意',
          text: '登录过期,请重新登录',
          buttonAccept: '确定',
          buttonsHidden: true,
          accept: () => {
            clearAndJumpLogin();
          }
        });
      }
    }

    return Promise.reject(error);
  }
);
export default service;
